import React from 'react'

const Footer = () => {
    return (
        <footer className="text-main relative isolate wrapper text-center p-4">
            Designed & Built by Natthida
        </footer>
    )
}

export default Footer